export enum COLLECTION {
  LECTURES = 'Lectures',
  COMMENT = 'Comments',
  REPILES = 'Replies',
  QAS = 'QAs',
  ANSWERS = 'Answers',
  REVIEWS = 'Reviews',
  NOTIFICATIONS = 'Notifications',
  USERS = 'Users',
}

export enum SVG_URL {
  DOG = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2FGroup%2081dog.svg?alt=media&token=c2ad4a83-a07b-46ad-a5ba-cf58c882ec38',
  MAIL = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2FFrame%20139.svg?alt=media&token=37804e30-182f-4079-970e-26797a096e7b',
  LOGIN = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2FFrame%20148%E0%B8%94%E0%B8%94.svg?alt=media&token=d7ce21e2-88fa-4ba9-9a16-cb6a51b4854b',
  REGISTER = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2FFrame%20149register.svg?alt=media&token=4b2ad375-e60d-4f8f-bb1a-dcdce174cbe4',
  HOME = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2FFrame%20150.svg?alt=media&token=a7b675bb-385c-4649-a4bf-340730fe855b',
  MONEY = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2Fcdownload%201.png?alt=media&token=9ad95554-1ddb-4d40-b593-06e95c6c8fa3',
  EASY_TO_USE = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2Fdownload%201.png?alt=media&token=9c9fe263-6ef0-435f-8b06-fdb15b72d4e4',
  USER_INTERFACE = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2Fdowxnload%201.png?alt=media&token=139ebda7-9916-48a8-b03f-1d492147d86b',
  GOOD_QUALITY = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2Fpasted%20image%200%201.png?alt=media&token=b4be3453-6866-46f9-9f71-92b28d5b34a5',
  MONITOR = 'https://firebasestorage.googleapis.com/v0/b/teletubby-v2.appspot.com/o/icons%2Funnamed%201.png?alt=media&token=3e5ed8b4-37f2-4812-ba45-35ac5d1bfede',
}
